import { defaultInputFieldColor, defaultInputFieldBorderColor, } from '../defaults';
export const extractInputFieldStyles = (customStyle, fallbackStyle) => {
    return {
        color: customStyle.color || fallbackStyle.color || defaultInputFieldColor,
        borderColor: customStyle.borderColor ||
            fallbackStyle.borderColor ||
            defaultInputFieldBorderColor,
    };
};
//# sourceMappingURL=extract-input-field-styles.js.map